import Vue from 'vue'
import {login, getInfo, logout} from '@/api/login'
import {ACCESS_TOKEN} from '@/store/mutation-types'
import {welcome} from '@/utils/util'

const user = {
    state: {
        token: '',
        name: '',
        welcome: '',
        avatar: '',
        roles: [],
        info: {},
    },

    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        SET_NAME: (state, {name, welcome}) => {
            state.name = name
            state.welcome = welcome
        },
        SET_AVATAR: (state, avatar) => {
            state.avatar = avatar
        },
        SET_ROLES: (state, roles) => {
            state.roles = roles
        },
        SET_INFO: (state, info) => {
            state.info = info
        },

    },

    actions: {
        // 登录
        Login({commit}, userInfo) {
            return new Promise((resolve, reject) => {
                login(userInfo).then(response => {
                    const result = response.result
                    Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
                    commit('SET_TOKEN', result.token)
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 获取用户获取权限

        // 登出
        Logout({commit, state}) {
            return new Promise((resolve) => {
                commit('SET_TOKEN', '')
                commit('SET_ROLES', [])
                Vue.ls.remove(ACCESS_TOKEN)

                logout(state.token).then(() => {
                    resolve()
                }).catch(() => {
                    resolve()
                })
            })
        },

        // 环信Login
        DO_Login_IM(commit, obj) {
            console.log(obj)
            var imConn = Vue.prototype.$imConn

            Vue.prototype.$imoption.user = obj.username
            Vue.prototype.$imoption.pwd = obj.password

            imConn.open(Vue.prototype.$imoption)

            imConn.listen({
                onOpened(message) {   // 建立连接
                    console.log('%c [opened] 成功连接 ', 'color: green')
                    console.log(message)
                    // 登陆状态
                    imConn.setPresence()
                    // 获取好友列表
                    imConn.getRoster({
                        success(lists) {
                            console.log('%c *** 好友列表 ***', 'color: blue')
                            console.log(lists)
                        }
                    })
                },
                onClosed(message) {  // 连接关闭
                    console.log('%c [close] 连接关闭 ', 'color: red')
                    console.log(message)
                },

                onTextMessage(message) {  // 接收文本消息
                    console.log('%c *** 接收到的文本Text消息 ***', 'color: green')
                    console.log(message)
                },
                onEmojiMessage(message) {  // 接收表情
                    console.log('%c [emoji] 表情', 'color: yellow')
                    console.log(message)
                },
                onPictureMessage(message) {  // 接收图片
                    console.log('%c [image] 接收图片', 'color: #2b99ff')
                    console.log(message)
                    let options = {url: message.url}
                    options.onFileDownloadComplete = function (data) {
                        console.log('%c *** 图片下载成功 ***', 'color: green')
                        console.log(data)
                    }
                    options.onFileDownloadError = function (err) {
                        console.log('%c *** 图片下载失败 ***', 'color: red')
                        console.log(err)
                    }
                    Vue.prototype.$WebIM.utils.download.call(Vue.prototype.$imConn, options)
                },

                onRoster(message) {
                    console.log('*** Roster ***')
                    console.log(message)
                },
                onError(error) {  // 错误监听
                    console.log(error)
                }
            })
        }

    }
}

export default user
